import React, { useEffect, useState } from 'react'

import "./navbar.scss";
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { setTheme } from '../../redux/themeSlice';
import { hasAnyRole, isAdmin } from '../../utils/roleUtils';

function Navbar() {
    const dispatch = useDispatch()
    const [companyType, setCompanyType] = useState([])

    const { token, user, role } = useSelector((state) => state.auth)
    const { theme } = useSelector((state) => state.theme)

    const getCompanyType = () => {
        axios.get(`${process.env.REACT_APP_SERVICE_URL}/company-type`, {
            headers: {
                Authorization: `Bearer ${token}`

            }
        })
            .then((response) => {
                //console.log(response.data)
                setCompanyType(response.data)
            })
            .catch((error) => {
                console.error(error)
            })
    }

    const changeTheme = () => {
        dispatch(setTheme({ theme: theme === 'dark' ? 'light' : 'dark' }))
    }

    useEffect(() => {
        getCompanyType()
    }, [])

    return (
        <nav className="navbar navbar-expand-lg bg-body border-bottom">
            <div className="container-fluid">
                <a className="navbar-brand" href="#">adatest</a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        {
                            isAdmin(role) && (
                                <li className="nav-item">
                                    <Link to="/dashboard" className="nav-link" aria-current="page">Başlangıç</Link>
                                </li>
                            )
                        }
                        <li className="nav-item">
                            <Link to="/requests" className="nav-link">Talepler</Link>
                        </li>
                        {
                            isAdmin(role) && (
                                <>
                                    <li className="nav-item">
                                        <Link to="/users" className="nav-link">Kullanıcılar</Link>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            Kullanıcı Tanımları
                                        </a>
                                        <ul className="dropdown-menu">
                                            {
                                                companyType?.map((item, index) => {
                                                    return <li key={index}><Link to={`/companies/${item.id}`} className="dropdown-item text-capitalize">{item.name}</Link></li>
                                                })
                                            }
                                            <li><hr className="dropdown-divider" /></li>
                                            <li>
                                                <Link to="/employees" className="dropdown-item">Çalışanlar</Link>
                                            </li>
                                            <li>
                                                <Link to="/cars" className="dropdown-item">Araçlar</Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/holidays" className="nav-link">Tatil Günleri</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/labs" className="nav-link">Bilgi Güncelle</Link>
                                    </li>

                                </>
                            )
                        }

                        {
                            hasAnyRole(role, 'MUHASEBE') && !isAdmin(role) && (
                                <li className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        Kullanıcı Tanımları
                                    </a>
                                    <ul className="dropdown-menu">
                                        {
                                            companyType?.map((item, index) => {
                                                return <li key={index}><Link to={`/companies/${item.id}`} className="dropdown-item text-capitalize">{item.name}</Link></li>
                                            })
                                        }
                                        <li><hr className="dropdown-divider" /></li>
                                        <li>
                                            <Link to="/employees" className="dropdown-item">Çalışanlar</Link>
                                        </li>
                                        <li>
                                            <Link to="/cars" className="dropdown-item">Araçlar</Link>
                                        </li>
                                    </ul>
                                </li>
                            )
                        }
                        <li className="nav-item">
                            <Link to="/logout" className="nav-link">Çıkış Yap</Link>
                        </li>
                    </ul>

                    <ul className='navbar-nav ms-auto mb-2 mb-lg-0'>
                        <li className='nav-item'>
                            <button type="button" className='btn btn-link nav-link text-body text-decoration-none border-0 btn-app btn-app--ghost'>
                                {user}
                            </button>
                        </li>
                        <li className='nav-item'>
                            <button type="button" className='btn btn-link nav-link text-body-secondary text-decoration-none border-0 btn-app btn-app--ghost' onClick={changeTheme} title={theme === 'dark' ? 'Açık tema' : 'Koyu tema'} aria-label={theme === 'dark' ? 'Açık temaya geç' : 'Koyu temaya geç'}>
                                {
                                    theme === 'dark' ? <i className="bi bi-moon"></i> : <i className="bi bi-brightness-high"></i>
                                }
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}

export default Navbar